export default __webpack_public_path__ + "static/media/archive.7f070c0c.jpg";